/* T8 shared rail controller — used by t8-product-rail, t8-instagram, t8-ugc-rail, t8-reviews-rail.
   Markup: <div class="t-railwrap" data-t8-rail>
             <div class="t-rail" data-t8-rail-track> …items… </div>
             <button data-t8-rail-prev> <button data-t8-rail-next>
             <div class="t-dots" data-t8-rail-dots></div>           (optional — one dot per scroll page)
             <div data-t8-rail-progress><i></i></div>              (optional — gold scroll progress line)
           </div> */
(function () {
  'use strict';
  function init(root) {
    (root || document).querySelectorAll('[data-t8-rail]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var track = wrap.querySelector('[data-t8-rail-track]') || wrap.querySelector('.t-rail');
      if (!track) return;
      var prev = wrap.querySelector('[data-t8-rail-prev]'), next = wrap.querySelector('[data-t8-rail-next]');
      var dots = wrap.querySelector('[data-t8-rail-dots]'), prog = wrap.querySelector('[data-t8-rail-progress]');
      var progBar = prog && (prog.firstElementChild || prog);

      function step() {
        var first = track.children[0]; if (!first) return track.clientWidth;
        var second = track.children[1];
        if (second && second.offsetParent === first.offsetParent) { var d = second.offsetLeft - first.offsetLeft; if (d > 0) return d; }   /* layout pitch: right even when cards are scaled (UGC coverflow) or carry margins */
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function pages() { var s = step(); return s ? Math.round(maxScroll() / s) + 1 : 1; }
      function buildDots() {
        if (!dots) return;
        var n = pages(); dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', (function (i) { return function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }; })(i));
          dots.appendChild(b);
        }
        dots.hidden = n < 2;
      }
      function update() {
        var x = track.scrollLeft, m = maxScroll();
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= m - 2;
        wrap.classList.toggle('is-start', x <= 2); wrap.classList.toggle('is-end', x >= m - 2);
        if (dots) { var i = Math.round(x / Math.max(1, step())); Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === i); }); }
        if (progBar) { var ratio = m ? x / m : 0; var w = progBar.getBoundingClientRect().width, W = (prog === progBar ? progBar.parentElement : prog).getBoundingClientRect().width; if (prog.hasAttribute('data-t8-rail-fill')) { progBar.style.width = (m ? 25 + 75 * ratio : 100) + '%'; } else { progBar.style.transform = 'translateX(' + Math.max(0, (W - w) * ratio) + 'px)'; } }   /* fill mode: 25% at the start → 100% at the end of the scroll */
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      var raf = 0; track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; update(); }); }, { passive: true });   /* every frame: progress / buttons follow the scroll smoothly */
      window.addEventListener('resize', function () { buildDots(); update(); });
      // drag to scroll (desktop)
      var down = false, sx = 0, sl = 0;
      // every press notes where the rail stood (a tap after a swipe must still open its link); only a mouse drags
      track.addEventListener('pointerdown', function (e) { sl = track.scrollLeft; if (e.pointerType !== 'mouse') return; down = true; sx = e.clientX; track.classList.add('is-dragging'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; track.scrollLeft = sl - (e.clientX - sx); });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); });
      track.addEventListener('click', function (e) { if (Math.abs(track.scrollLeft - sl) > 6 && e.target.closest('a')) e.preventDefault(); }, true);
      track.setAttribute('tabindex', track.getAttribute('tabindex') || '0');
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { track.scrollBy({ left: step(), behavior: 'smooth' }); e.preventDefault(); } if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step(), behavior: 'smooth' }); e.preventDefault(); } });
      buildDots(); update();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { buildDots(); update(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.T8Rail = { init: init };
})();
